export const AQUA_MODAL_TYPE = {
  MAP: 'map',
  YOUTUBE: 'youtube',
  HELP: 'help',
  FLOOR_PLAN: 'floorPlan',
};

export const AQUA_MAX_SOCIAL_MEDIA_DISPLAY = 4;
